
import { Box, ButtonBase, useTheme } from "@mui/material";
import { tokens } from "../../../../../theme";

import AddIcon from '@mui/icons-material/Add';
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
import ButtonGroup from "../../../../../components/theme/buttons/ButtonGroup";
import Shbutton from "../../../../../components/theme/buttons/Shbutton";
import ShTextSkeleton from "../../../../../components/theme/skeleton/ShTextSkeleton";
import { useGetCostsQuery } from "../../../../../newapi/financial/costSlice";
import { general_states } from "../../../../../utils/staticEnums";

import MAddCost from "../../../../../components/global/Modals/MAddCost";
import ShDataGrid2 from "../../../../../components/theme/datagrid2/ShDataGrid2";
import Text from "../../../../../components/theme/text/Text";

import ShLabel from "../../../../../components/theme/label/ShLabel";
import SidepanelLoader from "../../../../../components/theme/sidepanel2/SidepanelLoader";
import { selectUserPermission } from "../../../../../newapi/user/authentication/authSlice";
import { UserPrivileges } from "../../../../../utils/permissions";
import { useSelector } from "react-redux";
import { InvoiceCostsCard } from "../../../../../components/global/cards/financial/InvoiceCostsCard";
import { COST_FILTER_KEYS } from "../../../../../components/global/DataGrid/Filter";

const SpInvoiceProductDetails = SidepanelLoader(() => import("../../../../../components/global/Sidepanels/SpInvoiceProductDetails/SpInvoiceProductDetails"));
const SpShipperDetails = SidepanelLoader(() => import("../../../../../components/global/Sidepanels/SpShipperDetails/SpShipperDetails"));
const SpCostDetails = SidepanelLoader(() => import("../../../../../components/global/Sidepanels/SpCostDetails/SpCostDetails"));

const GridActions = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    return props.hasModifyPrivilege ?
        <ButtonGroup version={2}>
            <Shbutton 
                className={"group-btn"} 
                color={theme.palette.mode === "dark" ? "blue" : "primary"} 
                onClick={() => props.handleOpen(true)}
                endIcon={<AddIcon/>}
                variant="contained"
            >
                {t('new_cost')}
            </Shbutton>
        </ButtonGroup>
    : <></>;
}

let gridOptions = {
    export:true,
    disableCustomActionsOnPhone: true,
    isSidepanel: true,
    filter: [COST_FILTER_KEYS.TYPE,COST_FILTER_KEYS.INVOICE_TYPE,COST_FILTER_KEYS.SHIPPER],

};

const Costs = (props) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [data, setData] = useState([]);
    const [isExtended, setIsExtended] = useState(false);
    const [isShipperExtended, setIsShipperExtended] = useState(false);
    const [isCostExtended, setIsCostExtended] = useState(false);
    // const [selectedRowId, setSelectedRowId] = useState(-1);
    // const [rowSelected, setRowSelected] = useState(false);

    const hasModifyPrivilege = useSelector((state) =>
        selectUserPermission(state, [UserPrivileges.PRICEINCREASE_MANAGE])
    );
    
    const [spLoading, setSpLoading] = useState();
    const [spShipperLoading, setSpShipperLoading] = useState();
    const [spCostLoading, setSpCostLoading] = useState();

    const ref = useRef();
    const [config, setConfig] = useState({"state": general_states.ACTIVE});

    const [open, setOpen] = useState(false);

    const createContainerSizeModal = {
        open: open,
        setOpen: setOpen,
    }

    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions: gridOptions,
            mobileActions: <GridActions handleOpen={handleOpen} hasModifyPrivilege={hasModifyPrivilege}></GridActions>
        });

        return () => {
        }
    },[props.config]);

    const handleOpen = () => {
        setAddModalOpen(true);
    }
    

    const [addModalOpen, setAddModalOpen] = useState(false);
    const addModal = {
        open: addModalOpen,
        setOpen: setAddModalOpen
    }

    const handleClose = () => {
        setAddModalOpen(false);
    };

    const [invoiceProductId, setInvoiceProductId] = useState();
    const invoiceProductIdRef = useRef(invoiceProductId);
    
    const getInvoiceProduct = (params) => {
        if (!params) return;
    
        const newInvoiceProductId = parseInt(params.row.invoiceProduct.id);
        // Only update state if the pickingJobListId has actually changed
        if (invoiceProductIdRef.current !== newInvoiceProductId) {
            
            if(!spLoading) {
                setSpLoading(true);
            }
            setInvoiceProductId(newInvoiceProductId);
            invoiceProductIdRef.current = newInvoiceProductId; // Update the ref to the new value
        }

            setIsExtended(true);
    }

    const [costId, setCostId] = useState();
    const costIdRef = useRef(costId);
    
    const getCost = (params) => {
        if (!params) return;
    
        const newCostId = parseInt(params.row.id);
        // Only update state if the pickingJobListId has actually changed
        if (costIdRef.current !== newCostId) {
            
            if(!spCostLoading) {
                setSpCostLoading(true);
            }
            setCostId(newCostId);
            costIdRef.current = newCostId; // Update the ref to the new value
        }

            setIsCostExtended(true);
    }

    const [shipperId, setShipperId] = useState();
    const shipperIdRef = useRef(shipperId);
    
    const getShipper = (params) => {
        if (!params) return;
    
        const newShipperId = parseInt(params.row.shipper.id);
        // Only update state if the pickingJobListId has actually changed
        if (shipperIdRef.current !== newShipperId) {
            
            if(!spShipperLoading) {
                setSpShipperLoading(true);
            }
            setShipperId(newShipperId);
            shipperIdRef.current = newShipperId; // Update the ref to the new value
        }

            setIsShipperExtended(true);
    }


    const columns = [
        {
            field: "name",
            headerName: t("name"),
            flex:2,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                return params.row.name;
            }
        },
        {
            field: "type", 
            headerName: t("type"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                let labelColor = "grey";
                switch(params.row.type) {
                    case "shipment" :
                        labelColor = "blue";
                        break;
                    case "barcode" :
                        labelColor = "grey";
                        break;
                    case "inbound_manual" :
                    case "inbound_processing" :
                        labelColor = "purple";
                        break;
                    case "return" :
                    case "return_manual" :
                    case "return_shipment" :
                        labelColor = "lightblue";
                        break;
                    case "pickandpack" :
                    case "addonpickandpack" :
                        labelColor = "orange";
                        break;
                    case "storage_pallet" :
                    case "storage_product" :
                        labelColor = "pink";
                        break;
                    case "surcharges" :
                    case "adjustment_charges" :
                        labelColor = "grey";
                        break;
                    case "finalize_invoice" :
                        labelColor = "green";
                        break;
                    default:
                        labelColor = "grey";
                        break;
                }
                return (
                    <ShLabel fitted size={32} minWidth={150}  variant={labelColor}>
                      {t(params.row.type)}
                    </ShLabel>
                );
            }
        },
        {field: "invoiceType", headerName: t("invoice_type"),flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                // let labelColor = "grey";
                // switch(params.row.subType) {
                //     case "general" :
                //         labelColor = "grey";
                //         break;
                //     case "echeck" :
                //         labelColor = "blue";
                //         break;

                //     case "inbound" :
                //         labelColor = "yellow";
                //         break;

                //     case "repacking" :
                //         labelColor = "purple";
                //         break;

                // }
                // return (
                //     <ShLabel fitted size={32}  variant={labelColor}>
                //       {t(params.row.subType)}
                //     </ShLabel>
                // );
                return <Text> {t(`invoice_type_${params.row.invoiceType}`)}</Text>
            }
            // renderCell: (params) => {
            //     if(params.row.skeleton) {
            //         return <ShTextSkeleton/>
            //     }
            //     return t(params.row.subType);
            // }
        },
        {field: "shipper", headerName: t("shipper"),flex:1,
        renderCell: (params) => {
            if(params.row.skeleton) {
                return <ShTextSkeleton/>
            }

            if (!params.row.shipper?.name) {
                return <Text>-</Text>
            }

            return (
                <Box 
                    sx={{
                        width:'100%',
                        cursor:"pointer",
                        lineHeight:"64px",
                    }} 
                    onClick={(event) => {
                        event.stopPropagation();
                        // getPickingList(params);
                        getShipper(params);
                    }}
                >
                    <Text clickable semibold variant={theme.palette.mode === "dark" ? "blue" : "primary"}>{params.row.shipper.name}</Text>
                </Box>
            );
        }},
        {field: "invoiceProduct", headerName: t("invoice_product"),flex:1,
        renderCell: (params) => {
            if(params.row.skeleton) {
                return <ShTextSkeleton/>
            }

            if (!params.row.invoiceProduct?.name) {
                return <Text>-</Text>
            }

            return (
                <Box 
                    sx={{
                        width:'100%',
                        cursor:"pointer",
                        lineHeight:"64px",
                    }} 
                    onClick={(event) => {
                        event.stopPropagation();
                        // getPickingList(params);
                        getInvoiceProduct(params);
                    }}
                >
                    <Text clickable semibold variant={theme.palette.mode === "dark" ? "blue" : "primary"}>{params.row.invoiceProduct.name}</Text>
                </Box>
            );
        }},
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (params) => {
                return <InvoiceCostsCard onClick={() => getCost(params)} skeleton={params.row.skeleton ?? false} {...params.row} />
            }
        }
    ];

    return (
        <Box height={1} ref={ref} display={"flex"} flexDirection={"column"}>
            {/* <GridActions></GridActions> */}
            <ShDataGrid2 key={theme.palette.mode}
                content={useGetCostsQuery}
                config={config}
                gridActions={<GridActions handleOpen={handleOpen} hasModifyPrivilege={hasModifyPrivilege}></GridActions>} 
                title={t('costs')}
                gridOptions={gridOptions} 
                columns={columns}
                rows={data}
                onRowClick={getCost}
                sortModel={{field: columns[0].field,type:"ASC"}}
            >
            </ShDataGrid2>

            {spLoading && 
                <SpInvoiceProductDetails
                    invoiceProductId={invoiceProductId}
                    isExtended={isExtended}
                    setIsExtended={setIsExtended}
                    // data={pickingJobData}
                /> 
            }

            {spShipperLoading && 
                <SpShipperDetails
                    shipperId={shipperId}
                    isExtended={isShipperExtended}
                    setIsExtended={setIsShipperExtended}
                    // data={pickingJobData}
                /> 
            }
            {spCostLoading && 
                <SpCostDetails
                    costId={costId}
                    isExtended={isCostExtended}
                    setIsExtended={setIsCostExtended}
                /> 
            }
            <MAddCost onOpen={() => addModal.setOpen(true)} onClose={() => addModal.setOpen(false)} open={addModal.open} handleClose={handleClose} />
        </Box>
    );
}

export default Costs;